import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchPotentialParents } from "src/Pages/Company/OrganizationStructure/api";

export interface UsePotentialParentsParams {
  companyId: string;
  structureId: string;
  areaId: string;
  withManager?: string;
  query?: string | null;
  size?: number;
  enabled?: boolean;
}

export const usePotentialParents = ({
  companyId,
  structureId,
  areaId,
  withManager,
  query,
  size = 20,
  enabled = true,
}: UsePotentialParentsParams) =>
  useInfiniteQuery({
    enabled: enabled && !!companyId && !!structureId && !!areaId,
    queryKey: [
      "potential-parents",
      companyId,
      structureId,
      areaId,
      withManager,
      query,
      size,
    ],
    queryFn: ({ signal, pageParam }) =>
      fetchPotentialParents(companyId, structureId, areaId, {
        signal,
        nextCursor: pageParam as string | null,
        query,
        withManager,
        size,
      }),
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
